import React, {useContext, useMemo, useState} from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import logo from '../lib/assets/images/logo.png'
import OffCanvasMenu from './OffCanvasMenu';
import {useMode, UserContext} from "../lib/contexts";

import {
    IconButton,
    Box, Container,
    Grid,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    useMediaQuery,
    useTheme,
    Menu as MuiMenu,
    MenuItem,
} from "@mui/material";
import {Menu, ArrowDropDown} from '@mui/icons-material';

const Header = (props) => {
    const theme = useTheme();
    const matchSM = useMediaQuery(theme.breakpoints.down('sm'));
    const matchMD = useMediaQuery(theme.breakpoints.down('md'));
    const {
        state: {
            user_id
        },
        actions: {
            logout,
        },
    } = useContext(UserContext);
    const production = useMemo(() => {
        const host = window.location.hostname;
        return !host.includes('localhost') && !host.includes('staging');
    }, []);
    const paymentMethodUrl = production ? "https://billing.stripe.com/p/login/dRmaEYfdbahlgCkeJOfbq00" : "https://billing.stripe.com/p/login/test_5kA4hMbCbcxt5iwaEE"
    const { mode } = useMode();
    // Define nav items based on the mode
    let navItems = [];
    const [menuOpen, setMenuOpen] = useState(false);
    const [accountMenuAnchor, setAccountMenuAnchor] = useState(null);

    const handleDrawerToggle = () => {
        setMenuOpen(!menuOpen);
    };

    const handleAccountMenuOpen = (event) => {
        setAccountMenuAnchor(event.currentTarget);
    };

    const handleAccountMenuClose = () => {
        setAccountMenuAnchor(null);
    };

    const handleLogout = () => {
        logout();
        handleAccountMenuClose();
    };

    switch (mode) {
        case 'quote':
            navItems = [
                { name: 'Quote', path: '/quote' },
                { name: 'Track Shipments', path: '/' },
                //{ name: 'Settings', path: '/settings' },
                {
                    name: user_id ? "Account" : "Login",
                    onClick: user_id ? handleAccountMenuOpen : () => { },
                    isDropdown: user_id,
                    children: user_id ? [
                        { name: 'Payment Methods', path: paymentMethodUrl },
                        { name: 'Logout', onClick: handleLogout }
                    ] : []
                },
            ];
            break;
        case 'track':
            navItems = [
                { name: 'Track Shipment', path: '/track' },
                //{ name: 'Shipment History', path: '/history' },
                { name: 'FAQ', path: '/faq' },
                {
                    name: user_id ? "Account" : "Login",
                    onClick: user_id ? handleAccountMenuOpen : () => { },
                    isDropdown: user_id,
                    children: user_id ? [
                        { name: 'Payment Methods', path: paymentMethodUrl },
                        { name: 'Logout', onClick: handleLogout }
                    ] : []
                },
            ];
            break;
        case 'driver':
            navItems = [
                { name: 'Current Route', path: '/current' },
                { name: 'Past Routes', path: '/history' },
                //{ name: 'Expenses', path: '/expenses' },
                { name: 'Profile', path: '/profile' },
                {
                    name: user_id ? "Account" : "Login",
                    onClick: user_id ? handleAccountMenuOpen : () => { },
                    isDropdown: user_id,
                    children: user_id ? [
                        { name: 'Payment Methods', path: paymentMethodUrl },
                        { name: 'Logout', onClick: handleLogout }
                    ] : []
                },
            ];
            break;
        case 'dashboard':
            navItems = [
                { name: 'Dashboard', path: '/dashboard', mobileMenuOnly: true },
                { name: 'Quote', path: '/quote' },
                { name: 'Shipments', path: '/shipments' },
                { name: 'Map', path: '/map' },
                //{ name: 'Reports', path: '/reports' },
                //{ name: 'Settings', path: '/settings' },
                {
                    name: user_id ? "Account" : "Login",
                    onClick: user_id ? handleAccountMenuOpen : () => { },
                    isDropdown: user_id,
                    children: user_id ? [
                        { name: 'Payment Methods', path: paymentMethodUrl },
                        { name: 'Logout', onClick: handleLogout }
                    ] : []
                },
            ];
            break;
        default:
        case 'admin':
            navItems = [
                { name: 'Dashboard', path: '/dashboard', mobileMenuOnly: true },
                { name: 'Quote', path: '/quote' },
                { name: 'Shipments', path: '/history' },
                { name: 'Map', path: '/map' },
               // { name: 'Reports', path: '/reports' },
                {
                    name: user_id ? "Account" : "Login",
                    onClick: user_id ? handleAccountMenuOpen : () => { },
                    isDropdown: user_id,
                    children: user_id ? [
                        { name: 'Payment Methods', path: paymentMethodUrl },
                        { name: 'Logout', onClick: handleLogout }
                    ] : []
                },
            ];
            break;
    }

   // const disableNavigation = !(mode === 'admin' || mode === 'dashboard');
    const disableNavigation = false;

    return (
        <>

            <Box component="header" sx={{ width: '100%', position: 'sticky', top: 0, zIndex: 1100, backgroundColor: '#417E99', color: '#fff', height: 92 }}>
                <Container maxWidth={user_id ? 'lg' : 'md'}>
                    <Grid container alignItems="center" justifyContent="center">
                        <Grid item xs={12}>
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                marginTop: '10px',
                                justifyContent: user_id && !disableNavigation ? 'space-between' : 'center',
                                width: '100%'
                            }}>
                                <Link to="/">
                                    <img src={logo} alt="logo" style={{ marginTop: 15, height: 'auto', maxWidth: matchSM ? '90%' : 300 }} />
                                </Link>
                                {!disableNavigation && matchSM  && user_id && (
                                    <IconButton
                                        color="inherit"
                                        aria-label="open drawer"
                                        edge="start"
                                        onClick={handleDrawerToggle}
                                        sx={{ ml: 1, mt: 2 }}
                                    >
                                        <Menu />
                                    </IconButton>
                                )}
                                {!disableNavigation && user_id && (
                                    <>
                                        <Box sx={{ display: { xs: 'none', sm: 'flex' }, justifyContent: 'flex-end', width: '100%' }}>
                                            <nav>
                                                <List sx={{ display: 'flex', flexDirection: 'row', marginBottom: '-15px', padding: 0 }}>
                                                    {navItems.filter(item => !item.mobileMenuOnly).map((item, index) => (
                                                       <ListItem key={index} disablePadding sx={{ marginRight: theme.spacing(0) }} style={{ minWidth: 150, textAlign: 'center', alignContent: 'center', alignSelf: 'center', justifyContent: 'center', alignItems: 'center', justifyItems: 'center' }}>
                                                           <ListItemButton
                                                              component={item.path && !item.isDropdown ? "a" : "div"}
                                                              href={item.path && !item.isDropdown ? item.path : undefined}
                                                              onClick={item.onClick ? item.onClick : undefined}
                                                              sx={{
                                                                  textAlign: 'center',
                                                                  alignContent: 'center',
                                                                  alignSelf: 'center',
                                                                  justifyContent: 'center',
                                                                  alignItems: 'center',
                                                                  justifyItems: 'center',
                                                                  flex: 'none',
                                                                  '&:hover': {
                                                                      textDecoration: 'none',
                                                                      color: 'inherit'
                                                                  },
                                                                  textDecoration: 'none',
                                                                  color: 'inherit'
                                                              }}
                                                           >
                                                               <ListItemText primary={item.name} />
                                                               {item.isDropdown && <ArrowDropDown />}
                                                           </ListItemButton>
                                                       </ListItem>
                                                    ))}
                                                </List>
                                            </nav>
                                        </Box>
                                    </>
                                )}
                            </Box>

                        </Grid>
                    </Grid>
                </Container>
            </Box>
            
            {/* Account Dropdown Menu */}
            <MuiMenu
                anchorEl={accountMenuAnchor}
                open={Boolean(accountMenuAnchor)}
                onClose={handleAccountMenuClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <MenuItem
                    component="a"
                    href={paymentMethodUrl}
                    onClick={handleAccountMenuClose}
                >
                    Payment Methods
                </MenuItem>
                <MenuItem onClick={handleLogout}>
                    Logout
                </MenuItem>
            </MuiMenu>

            {!disableNavigation && user_id &&
                <OffCanvasMenu navItems={navItems} open={menuOpen} setMenuOpen={setMenuOpen}></OffCanvasMenu>}
        </>
    );
}

export default Header;
